import React, { FunctionComponent } from 'react';

import AppPage from '@/ui/AppPage/AppPage';
import DataCentricPage from '@/ui/DataCentric/DataCentricPage';
import Permissions from '@/lib/permissions';
import modelJLS from '@/models/jls';
import modelPPRegistar from '@/models/pp_registar';

const PPRegistarDataCentricPage: FunctionComponent = () => (
  <AppPage titlett="pp:page.registar" needPermission={[Permissions.PPRegistarView]}>
    <DataCentricPage
      baseRecordPath={modelJLS.apiPath}
      childRecordRelativePath="registar"
      primaryModel={modelJLS}
      primaryTitleToken="pp:titles.jls"
      primaryView="default"
      primaryAllowView
      secondaryModel={modelPPRegistar}
      secondaryTitleToken="pp:titles.registar"
      secondaryView="default"
      secondaryAllowView
      secondaryAllowColumnPicker
      secondaryAllowFilter
      secondaryAllowExport
      geomRelativePath=""
      mapId={72}
      mapModel={modelJLS}
    />
  </AppPage>
);

export default PPRegistarDataCentricPage;
